import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { FaStar } from "react-icons/fa";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      {/* Hero Banner */}
      <section className="hero-banner">
        <div
          className="hero-bg"
          style={{ backgroundImage: `url('/assets/products/product-25-gallery.webp')` }}
        ></div>
        <div className="hero-content">
          <p className="hero-subtitle">NEW SEASON EDIT</p>
          <h1 className="hero-title">LIVE WELL</h1>
          <Link onClick={toTop} to="/shop" className="shop-btn">
            SHOP
          </Link>
        </div>
      </section>

      {/* Wardrobe edit */}
      <section className="brands-section">
        <h2 className="section-title">THE EVERYDAY WARDROBE</h2>
        <div className="brands-grid">
          {[
            { img: "/assets/products/product-01-gallery.webp", name: "EASY DRESSES" },
            { img: "/assets/products/product-02-gallery.webp", name: "RELAXED SHIRTS" },
            { img: "/assets/products/product-03-gallery.webp", name: "SOFT TROUSERS" },
            { img: "/assets/products/product-04-gallery.webp", name: "LIGHT LAYERS" },
            { img: "/assets/products/product-05-gallery.webp", name: "MIDI SKIRTS" },
            { img: "/assets/products/product-06-gallery.webp", name: "TAILORING" },
            { img: "/assets/products/product-07-gallery.webp", name: "COTTON KNITS" },
            { img: "/assets/products/product-08-gallery.webp", name: "DAILY BASICS" },
          ].map((brand, idx) => (
            <div className="brand-card" key={idx}>
              <img src={brand.img} alt={brand.name} />
              <h3>{brand.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Home & Gift Collections */}
      <section className="collections-section">
        <h2 className="section-title">OUR FAVE HOME & GIFT COLLECTIONS</h2>
        <div className="collections-grid">
          {[
            { img: "/assets/products/product-14-gallery.webp", name: "WARM LIGHTING" },
            { img: "/assets/products/product-15-gallery.webp", name: "CERAMIC FORMS" },
            { img: "/assets/products/product-18-gallery.webp", name: "SOFT TEXTILES" },
            { img: "/assets/products/product-17-gallery.webp", name: "NATURAL WOOD" },
            { img: "/assets/products/product-22-gallery.webp", name: "BATH ESSENTIALS" },
            { img: "/assets/products/product-21-gallery.webp", name: "HOME FRAGRANCE" },
          ].map((col, idx) => (
            <div className="collection-card" key={idx}>
              <img src={col.img} alt={col.name} />
              <h3>{col.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Conscious Fashion */}
      <section className="conscious-fashion">
        <div className="cf-image">
          <img src="/assets/products/product-12-gallery.webp" alt="Considered everyday clothing" />
        </div>
        <div className="cf-text">
          <h2>CONSIDERED EVERYDAY DESIGN</h2>
          <p>
            baplehollow brings together useful clothing and home pieces chosen
            for comfortable materials, practical details and a calm, lasting
            look. Every product is described plainly so you can choose with confidence.
          </p>
          <Link onClick={toTop} to="/shop" className="cf-btn">
            SHOP THE EDIT
          </Link>
        </div>
      </section>

      {/* Customer Reviews */}
      <section className="reviews-section">
        <h2 className="section-title">HERE'S WHAT OUR CUSTOMERS ARE SAYING</h2>
        <div className="reviews-header">
          <div className="stars-main">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
          </div>
          <p className="review-count">recent verified feedback</p>
        </div>

        <div className="reviews-grid">
          <div className="review-card">
            <img src="/assets/products/product-20-gallery.webp" alt="Warm brown crossbody bag" />
            <div className="review-content">
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <h4>Exactly what I needed</h4>
              <p>
                The size is practical, the finish feels natural and the photos
                matched what arrived.
              </p>
              <p className="author">Mina C.</p>
            </div>
          </div>
          <div className="review-card">
            <img src="/assets/products/product-10-gallery.webp" alt="Lavender midi dress" />
            <div className="review-content">
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <h4>Lovely everyday dress</h4>
              <p>Soft, easy to wear and true to the measurements.</p>
              <p className="author">Christine L.</p>
            </div>
          </div>
          <div className="review-card">
            <img src="/assets/products/product-13-gallery.webp" alt="Speckled stoneware mugs" />
            <div className="review-content">
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <h4>Comfortable mug pair</h4>
              <p>
                Great communication, fast service and lovely special coffee mug!
              </p>
              <p className="author">Jenni R.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Arrivals */}
      <section className="latest-arrivals">
        <h2 className="section-title">LATEST ARRIVALS</h2>
        <p className="arrivals-subtitle">
          Fresh clothing, accessories and useful home pieces selected for simple,
          comfortable everyday living.
        </p>

        <div className="products-grid">
          {productData.map((product) => (
            <Link
              onClick={toTop}
              to={`/shopDetails/${product.id}`}
              className="product-card"
              key={product.id}
            >
              <div className="img-container">
                <img src={product.homeImage} alt={product.name} />
                <span className="badge-new">NEW</span>
              </div>
              <div className="product-info">
                <h3>{product.name.toUpperCase()}</h3>
                <p className="price">${product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* About Brand Banner */}
      <section className="about-brand-banner">
        <h2>
          baple
          <br />
          hollow
        </h2>
      </section>

      {/* Split Info Sections */}
      <section className="split-info-section">
        <div className="split-row">
          <div className="split-img">
            <img src="/assets/products/product-24-gallery.webp" alt="Fluted glass homeware" />
          </div>
          <div className="split-content">
            <div className="text-inner">
              <p>
                baplehollow is an online clothing, accessory and homeware store
                operated from Hong Kong.
              </p>
              <p>
                We focus on useful, easy-to-style pieces with clear product
                information, straightforward pricing in USD and helpful customer care.
              </p>
            </div>
          </div>
        </div>

        <div className="split-row">
          <div className="split-content">
            <div className="text-inner">
              <p>
                Our collection balances relaxed clothing with practical objects
                for daily routines at home and away.
              </p>
              <p>
                We keep product descriptions specific and use distinct, detailed
                photography so materials, proportions and finishes are easy to understand.
              </p>
            </div>
          </div>
          <div className="split-img">
            <img src="/assets/products/product-23-gallery.webp" alt="Organised home workspace" />
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="news-section">
        <h2 className="section-title">BAPLEHOLLOW NOTES</h2>
        <div className="news-grid">
          {/* News Card 1 */}
          <div className="news-card">
            <div className="news-img">
              <img src="/assets/products/product-09-gallery.webp" alt="Soft knitwear texture" />
            </div>
            <div className="news-content">
              <h3>BUILDING A USEFUL CAPSULE WARDROBE</h3>
              <p className="news-meta">September 12, 2026 • 3 min read</p>
              <p>
                Start with comfortable layers, a consistent palette and pieces
                that work across more than one part of your day.
              </p>
            </div>
          </div>

          {/* News Card 2 */}
          <div className="news-card">
            <div className="news-img">
              <img src="/assets/products/product-16-gallery.webp" alt="Linen cushion styling" />
            </div>
            <div className="news-content">
              <h3>TEXTURE MAKES A QUIET ROOM FEEL WARM</h3>
              <p className="news-meta">September 05, 2026 • 2 min read</p>
              <p>
                Washed linen, natural wood and soft woven cotton add depth
                without making a small space feel busy.
              </p>
            </div>
          </div>

          {/* News Card 3 */}
          <div className="news-card">
            <div className="news-img">
              <img src="/assets/products/product-19-gallery.webp" alt="Olive canvas tote" />
            </div>
            <div className="news-content">
              <h3>ONE BAG, MANY ROUTINES</h3>
              <p className="news-meta">August 28, 2026 • 2 min read</p>
              <p>
                A well-shaped tote can move from weekday errands to short trips;
                reinforced handles and simple pockets make the difference.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
